<div class="flex item-center">
@switch (labelSide()) {
    @case ('left') {
        @if (label()) {
            <label class="mr-1">{{ label() }}</label>
        }
        @if (control(); as ctrl) {
            <p-checkbox [formControl]="ctrl" [binary]="true" />
        } 
        }
    @case ('right')
    @default {
        @if (control(); as ctrl) {
            <p-checkbox [formControl]="ctrl" [binary]="true" />
        } 
        @if (label()) {
            <label class="ml-1">{{ label() }}</label>
        }
    }
}  
</div>